<template>
	<div id="UI"
	v-bind:class="{
		['noselect'] : true,
		['closed'] : closed
	}"
	>
		<div id="UI_save">
			<div class="save" v-on:click="saveMap"></div>
			<input type="text" v-model="okanMap.saveName" />
		</div>

		<div id="UI_load">
			<input type="file" v-on:change="uploadMapFile" />
		</div>

		<div id="UI_close" v-on:click="closed = !closed"></div>
		<div id="UI_menu">

			<div class="menu_tab sources"
			v-bind:class="{
				['current'] : currentTab == 'sources'
			}"
			v-on:click="currentTab = 'sources'"></div>
			<div class="menu_tab layers"
			v-bind:class="{
				['current'] : currentTab == 'layers'
			}"
			v-on:click="currentTab = 'layers'"></div>
			<div class="menu_tab map"
			v-bind:class="{
				['current'] : currentTab == 'map'
			}"
			v-on:click="currentTab = 'map'"></div>

			<div class="menu_tab filters"
			v-bind:class="{
				['current'] : currentTab == 'filters'
			}"
			v-on:click="currentTab = 'filters'"></div>

		</div>
		<div id="UI_content">

			<UISources v-bind:okanMap="okanMap"
			v-if="currentTab == 'sources'" />

			<UILayers v-bind:okanMap="okanMap" 
			v-if="currentTab == 'layers'" />

			<UIMap v-bind:okanMap="okanMap" 
			v-if="currentTab == 'map'" />

			<UIFilters v-bind:okanMap="okanMap" 
			v-if="currentTab == 'filters'" />

		</div>

	</div>
</template>

<script>

import UISources from './UISources.vue'
import UILayers from './UILayers.vue'
import UIMap from './UIMap.vue'
import UIFilters from './UIFilters.vue'

export default {
	name: 'UI',
	components: {
		UISources,
		UILayers,
		UIMap,
		UIFilters
	},
	props: {
		okanMap : Object
	},
	data: function() {
		return {

			currentTab: 'sources',
			closed: false

		}
	},
	mounted() {

	},
	created() {

	},
	destroyed() {

	},
	methods : {

		init() {
		},

		saveMap(){
			this.okanMap.saveMap();
		},

		uploadMapFile(e){
			if(e != undefined && e != null){
				if(e.target.files[0] != undefined){
					this.okanMap.loadMap(e.target.files[0]);
				}
			}
		}

	}
}
</script>

<style scoped src="../assets/css/ui.css"></style>
